import { yupResolver } from '@hookform/resolvers/yup'
import React, { useEffect, useState } from 'react'
import { Controller, useForm } from 'react-hook-form'
import { cancelChecklistResignAPI } from '../../../services/checklist'
import SwalCustom from '../../../alert/swal-custom'
import { TXTSUCCESS } from '../../../Constants'
import ModalCustom from '../../modal-custom'
import Error_false from '../../error/error-false'
import Error_500 from '../../error/error-500'
import { Button, Col, Form, Row } from 'react-bootstrap'
import LabelCustom from '../../label-custom'
import moment from 'moment'
import * as yup from 'yup'

const schema = yup
  .object({
    comment: yup.string().required('โปรดระบุข้อมูล'),
    type: yup.object().required('โปรดระบุข้อมูล')
  })
  .required()
export default function ModalCancel({
  open,
  onCancel,
  data,
  resignsOption,
  fnData,
  page,
  statusId
}) {
  const [isSave, setIsSave] = useState(false)
  const {
    control,
    setValue,
    reset,
    handleSubmit,
    formState: { errors }
  } = useForm({
    resolver: yupResolver(schema)
  })

  useEffect(() => {
    resignsOption.length > 7 && setValue('type', resignsOption[7])

    if (data) {
      setValue('comment', '')
    }
  }, [resignsOption, setValue, data])

  
  const onSubmit = async (d) => {
    try {
      setIsSave(true)
      const body = {
        orgId: data.org_id,
        clrNo: data?.clr_no,
        cancelDescription: d.comment
      }
      const resp = await cancelChecklistResignAPI(body)
      setIsSave(false)
      if (!resp) return
      if (resp.status) {
        SwalCustom({
          title: `Success!`,
          text: TXTSUCCESS,
          timer: 1500,
          showConfirmButton: false
        }).then(() => {
          onCancel()
          fnData({ orgId: data.org_id, clrNo: data?.clr_no, page: page, statusId: statusId })
          reset()
        })
      } else {
        Error_false(resp)
      }
    } catch (error) {
      Error_500(error)
    }
  }

  return (
    <ModalCustom open={open} onCancel={onCancel}>
      {isSave && <div className="preloader"></div>}

      <h5 className="text-danger">ยกเลิกรายการ</h5>
      <span>เลขที่: {data?.clr_no}</span>
      <Row className="mt-3">
        <Col xl={6}>
          <LabelCustom text="รหัสพนักงาน" />
          <p>{data?.code}</p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="วันที่พ้นสภาพ	" />
          {data?.end_date === '0000-00-00' ? (
            <p>-</p>
          ) : (
            <p>
              {data && data.end_date
                ? moment(data.end_date).format('DD/MM/YYYY')
                : '-'}
            </p>
          )}
        </Col>
        <Col xl={6}>
          <LabelCustom text="	ชื่อ-นามสกุล	" />
          <p>
            {data?.name_th} {data?.surname_th}
          </p>
        </Col>
        <Col xl={6}>
          <LabelCustom text="	ตำแหน่ง" />
          <p>{data?.position_th || '-'}</p>
        </Col>
      </Row>
      <Form onSubmit={handleSubmit(onSubmit)}>
        <Row>
          <Col xl={12} className="mt-3">
            <LabelCustom text="รายละเอียด" />
            <Controller
              control={control}
              rules={{
                required: true
              }}
              render={({ field: { onChange, value } }) => (
                <Form.Control
                  as="textarea"
                  rows={3}
                  value={value}
                  onChange={onChange}
                />
              )}
              name="comment"
            />
            {errors.comment && (
              <label className="small text-danger">
                {errors.comment.message}
              </label>
            )}
          </Col>
        </Row>

        <Row>
          <Col xl={12} className="text-end mt-4">
            <Button type="button" variant="secondary" onClick={onCancel}>
              ปิด
            </Button>
            <Button type="submit" disabled={isSave} className="px-4 ms-2">
              {isSave ? 'กำลังบันทึก...' : 'บันทึก'}
            </Button>
          </Col>
        </Row>
      </Form>
    </ModalCustom>
  )
}
